import { NumericFormat } from "react-number-format";
import Table from "../../../components/Table";
import { useState } from 'react';
import moment from 'moment';

export default function GetCash({ cashData, setState, textView = 'Tiền mặt' }) {
    function onCompletedInputCash(e) {
        const id = Number(e.target.id);
        let value = e.target.value;
        console.log(value);
        value = value.replaceAll(',', '');
        value = Number(value);
        if (!isNaN(value)) {
            const target = cashData.find(item => item.id === id);
            target.cash = Math.abs(value) || 0;
            setState(cashData);
            e.target.value = value.toLocaleString();
        } else {
            e.target.value = 0;
        }
    }
    function onChangeCash(e) {
        let value = e.target.value;
        value = value.replaceAll(',', '');
        value = Number(value);
        if (!isNaN(value)) {
            e.target.value = value.toLocaleString();
        } else {
            e.target.value = 0;
        }
    }



    function onChangeNote(e) {
        const id = Number(e.target.id.replaceAll('note-', ''));
        const value = e.target.value;
        const target = cashData.find(item => item.id === id);
        target.note = value;
        console.log(target.note);
        setState(cashData);
    }

    const columns = [
        {
            header: "Ca Làm việc [Cash Input/Cash Actual]",
            accessor: "label",
            Cell: ({ cell }) => (cell)
        },
        {
            header: "Tiền mặt thực nhận",
            Cell: ({ cell, original }) => {
                return (
                    <input
                        id={original.id}
                        type="text"
                        className="form-input"
                        onBlur={onCompletedInputCash}
                        onChange={onChangeCash}
                    />
                )
            }
        },
        {
            header: "Ghi Chú",
            Cell: ({ cell, original }) => {
                const id = `note-${original.id}`;
                return (
                    <input
                        id={id}
                        type="text"
                        className="form-input"
                        onBlur={onChangeNote}
                        defaultValue={cell}
                    />
                )
            }
        }
    ];

    // Tạo dữ liệu cho table Chi Tiết
    const detailData = cashData.filter(item => item.detail).map(item => ({
        ...item,
        startTime: item.minTime ? moment(item.minTime * 1000).format('HH:mm') : 'N/A',
        endTime: item.maxTime ? moment(item.maxTime * 1000).format('HH:mm') : 'N/A'
    }));

    // Tính tổng các cột
    const totals = detailData.reduce((acc, item) => {
        if (item.detail) {
            acc.cash += item.detail.cash || 0;
            acc.card += item.detail.card || 0;
            acc.bank_transfer += item.detail.bank_transfer || 0;
            acc.grab_food += item.detail.grab_food || 0;
            acc.shopee_food += item.detail.shopee_food || 0;
            acc.shopee_mall += item.detail.shopee_mall || 0;
            acc.unknown += item.detail.unknown || 0;
            acc.total += item.detail.total || 0;
        }
        return acc;
    }, {
        cash: 0,
        card: 0,
        bank_transfer: 0,
        grab_food: 0,
        shopee_food: 0,
        shopee_mall: 0,
        unknown: 0,
        total: 0
    });

    const detailColumns = [
        {
            header: "Ca làm việc",
            accessor: "staffName",
            Cell: ({ cell, original }) => cell || original.label || 'N/A'
        },
        {
            header: "Thời gian bắt đầu",
            accessor: "startTime",
            Cell: ({ cell, original }) => original.startTime || 'N/A'
        },
        {
            header: "Thời gian kết thúc",
            accessor: "endTime",
            Cell: ({ cell, original }) => original.endTime || 'N/A'
        },
        {
            header: "Tiền mặt",
            accessor: "detail.cash",
            Cell: ({ cell, original }) => (
                <NumericFormat
                    thousandSeparator={true}
                    value={cell || original.detail?.cash || 0}
                    displayType="text"
                    suffix=" ₫"
                />
            )
        },
        {
            header: "Thẻ tín dụng",
            accessor: "detail.card",
            Cell: ({ cell, original }) => (
                <NumericFormat
                    thousandSeparator={true}
                    value={cell || original.detail?.card || 0}
                    displayType="text"
                    suffix=" ₫"
                />
            )
        },
        {
            header: "Chuyển khoản",
            accessor: "detail.bank_transfer",
            Cell: ({ cell, original }) => (
                <NumericFormat
                    thousandSeparator={true}
                    value={cell || original.detail?.bank_transfer || 0}
                    displayType="text"
                    suffix=" ₫"
                />
            )
        },
        {
            header: "Grab Food",
            accessor: "detail.grab_food",
            Cell: ({ cell, original }) => (
                <NumericFormat
                    thousandSeparator={true}
                    value={cell || original.detail?.grab_food || 0}
                    displayType="text"
                    suffix=" ₫"
                />
            )
        },
        {
            header: "Shopee Food",
            accessor: "detail.shopee_food",
            Cell: ({ cell, original }) => (
                <NumericFormat
                    thousandSeparator={true}
                    value={cell || original.detail?.shopee_food || 0}
                    displayType="text"
                    suffix=" ₫"
                />
            )
        },
        {
            header: "Shopee Mall",
            accessor: "detail.shopee_mall",
            Cell: ({ cell, original }) => (
                <NumericFormat
                    thousandSeparator={true}
                    value={cell || original.detail?.shopee_mall || 0}
                    displayType="text"
                    suffix=" ₫"
                />
            )
        },
        {
            header: "Không xác định",
            accessor: "detail.unknown",
            Cell: ({ cell, original }) => (
                <NumericFormat
                    thousandSeparator={true}
                    value={cell || original.detail?.unknown || 0}
                    displayType="text"
                    suffix=" ₫"
                />
            )
        },
        {
            header: "Tổng cộng",
            accessor: "detail.total",
            Cell: ({ cell, original }) => (
                <NumericFormat
                    thousandSeparator={true}
                    value={cell || original.detail?.total || 0}
                    displayType="text"
                    suffix=" ₫"
                />
            )
        }
    ];

    return (
        <>
            <div className="report-table">
                <h3 className="report-table-title">{textView}</h3>
                <Table columns={columns} data={cashData} />
            </div>

            {detailData.length > 0 && (
                <div className="report-table" style={{ marginTop: '30px' }}>
                    <h3 className="report-table-title">Chi Tiết</h3>
                    <Table columns={detailColumns} data={detailData} />
                    
                    {/* Hiển thị tổng cộng */}
                    <div className="totals-summary">
                        <h4>Tổng cộng:</h4>
                        <div className="totals-grid">
                            <div className="total-item">
                                <span className="label">Tiền mặt:</span>
                                <span className="value cash">{totals.cash.toLocaleString('vi-VN')} ₫</span>
                            </div>
                            <div className="total-item">
                                <span className="label">Thẻ tín dụng:</span>
                                <span className="value card">{totals.card.toLocaleString('vi-VN')} ₫</span>
                            </div>
                            <div className="total-item">
                                <span className="label">Chuyển khoản:</span>
                                <span className="value bank">{totals.bank_transfer.toLocaleString('vi-VN')} ₫</span>
                            </div>
                            <div className="total-item">
                                <span className="label">Grab Food:</span>
                                <span className="value grab">{totals.grab_food.toLocaleString('vi-VN')} ₫</span>
                            </div>
                            <div className="total-item">
                                <span className="label">Shopee Food:</span>
                                <span className="value shopee">{totals.shopee_food.toLocaleString('vi-VN')} ₫</span>
                            </div>
                            <div className="total-item">
                                <span className="label">Shopee Mall:</span>
                                <span className="value shopee">{totals.shopee_mall.toLocaleString('vi-VN')} ₫</span>
                            </div>
                            <div className="total-item">
                                <span className="label">Không xác định:</span>
                                <span className="value unknown">{totals.unknown.toLocaleString('vi-VN')} ₫</span>
                            </div>
                            <div className="total-item">
                                <span className="label">Tổng cộng:</span>
                                <span className="value total">{totals.total.toLocaleString('vi-VN')} ₫</span>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
